export enum MediaStatus {
  UPLOADED = "uploaded",
  PROCESSING = "processing",
  PROCESSING_AI = "processing_ai",
  READY = "ready",
  FAILED = "failed",
  ARCHIVED = "archived",
}

export enum MediaStage {
  DRAFT = "draft",
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  DISCARDED = "discarded",
  LEGACY_USED = "legacy_used",
  ARCHIVED = "archived",
}

export const VALID_MEDIA_STAGES = [
  MediaStage.DRAFT,
  MediaStage.PENDING_APPROVAL,
  MediaStage.APPROVED,
  MediaStage.DISCARDED,
  MediaStage.LEGACY_USED,
  MediaStage.ARCHIVED,
] as const;

export type ValidMediaStages = MediaStage;

// Helper type for stages with no_stage option
export type MediaStageWithNone = MediaStage | "no_stage";

export enum MediaStageWithNoneEnum {
  DRAFT = "draft",
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  DISCARDED = "discarded",
  LEGACY_USED = "legacy_used",
  ARCHIVED = "archived",
  NO_STAGE = "no_stage",
}

export const DISPLAYABLE_STAGES = [
  MediaStage.DRAFT,
  MediaStage.PENDING_APPROVAL,
  MediaStage.APPROVED,
  MediaStage.LEGACY_USED,
] as const;

// Legacy type alias for backward compatibility
export type MediaStageType = MediaStage;

export enum PostStatus {
  AI_GENERATED = "ai_generated",
  DRAFT = "draft",
  CAPTION_GENERATED = "caption_generated",
  APPROVAL_PENDING = "approval_pending",
  READY = "ready",
  SCHEDULED = "scheduled",
  PARTIALLY_PUBLISHED = "partially_published",
  PUBLISHED = "published",
  ARCHIVED = "archived",
}

export enum MediaFilterTab {
  ALL = "all",
  DRAFT = "draft",
  PENDING_APPROVAL = "pending_approval",
  APPROVED = "approved",
  DISCARDED = "discarded",
  LEGACY_USED = "legacy_used",
  ARCHIVED = "archived",
}

export const DRAFT_POST_STATUSES = [
  PostStatus.DRAFT,
  PostStatus.READY,
  PostStatus.CAPTION_GENERATED,
  PostStatus.APPROVAL_PENDING,
] as const;

export const ACTIVE_POST_STATUSES = [
  PostStatus.SCHEDULED,
  PostStatus.PUBLISHED,
] as const;